import { render, staticRenderFns } from "./ShipmentDetailCancelButton.vue?vue&type=template&id=2dbdfe9c&scoped=true"
import script from "./ShipmentDetailCancelButton.vue?vue&type=script&lang=js"
export * from "./ShipmentDetailCancelButton.vue?vue&type=script&lang=js"
import style0 from "./ShipmentDetailCancelButton.vue?vue&type=style&index=0&id=2dbdfe9c&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbdfe9c",
  null
  
)

export default component.exports